import { useCallback, useEffect } from 'react';

const lAST_SEEN_POST_ID = 'last_post_id';
const COMMUNITY_VISITED = 'visited_community';

export const COMMUNITY_UNREAD_CHANGED_EVENT = 'community-unread-changed';

export const notifyCommunityUnreadChanged = () => {
  window.dispatchEvent(new Event(COMMUNITY_UNREAD_CHANGED_EVENT));
};

export const useCommunityIndicator = (isCommunityPage?: boolean) => {
  useEffect(() => {
    if (isCommunityPage) {
      const visitedCommunity = localStorage.getItem(`${COMMUNITY_VISITED}`);
      if (!visitedCommunity) {
        localStorage.setItem(COMMUNITY_VISITED, JSON.stringify(true));
        notifyCommunityUnreadChanged();
      }
    }
  }, []);

  const isCommunityVisited = () => {
    const visitedCommunity = localStorage.getItem(COMMUNITY_VISITED);
    return !!visitedCommunity;
  };

  const getLastSeenPostId = () => {
    const savedLastSeenPostId = localStorage.getItem(lAST_SEEN_POST_ID);
    return JSON.parse(savedLastSeenPostId ?? 'null');
  };

  const setLastSeenPostId = useCallback((id: string) => {
    const next = JSON.stringify(id);
    if (localStorage.getItem(lAST_SEEN_POST_ID) === next) return;
    localStorage.setItem(lAST_SEEN_POST_ID, next);
    notifyCommunityUnreadChanged();
  }, []);

  return {
    getLastSeenPostId,
    setLastSeenPostId,
    isCommunityVisited,
  };
};
